export var DEPLOY_DATE = new Date('2026-07-28T09:47:53+0000');
